/*
 * Site languages — the ONE list (2026-09-30). Adding a language: add it here, in
 * src/Core/Hunt.php (LANGS), in the translations files (public/sounds/translations.json,
 * public/translations.json) and in the data builds' LANGS (bin/codex-build.py, loadout-build.py,
 * loot-build.py, maps-details.php). Site texts are translated; game texts come from the game's
 * own localization (datamine exports carry 14 languages).
 */
export var LANGS = ['en', 'fr', 'de', 'es', 'it', 'pt', 'pl', 'ru', 'zh', 'ja'];
export var LANG_NAMES = { en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español', it: 'Italiano', pt: 'Português', pl: 'Polski', ru: 'Русский', zh: '简体中文', ja: '日本語' };
export var LOCALES = { en: 'en-GB', fr: 'fr-FR', de: 'de-DE', es: 'es-ES', it: 'it-IT', pt: 'pt-BR', pl: 'pl-PL', ru: 'ru-RU', zh: 'zh-CN', ja: 'ja-JP' };

/** A supported language code for any input ("fr-CA" → "fr", "zh-Hans" → "zh"), else null. */
export function normLang(l) {
	var k = String(l || '').toLowerCase().split(/[-_]/)[0];
	return LANGS.indexOf(k) !== -1 ? k : null;
}
/** Stored choice, else the browser's preferred languages, else English. */
export function detectLang(stored) {
	var s = normLang(stored);
	if (s) return s;
	var prefs = (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language])) || [];
	for (var i = 0; i < prefs.length; i++) { var n = normLang(prefs[i]); if (n) return n; }
	return 'en';
}
export function localeOf(l) { return LOCALES[normLang(l) || 'en']; }
/** Text of a {lang: text} object in the current language, English fallback. */
export function pick(o, l) { return o ? (o[l] || o.en || '') : ''; }

if (typeof window !== 'undefined') window.__huntLangs = { LANGS: LANGS, LANG_NAMES: LANG_NAMES, normLang: normLang, detectLang: detectLang, localeOf: localeOf };

/**
 * Data file in one language: <name>.json → <name>.<lang>.json (published by the data builds,
 * see bin/i18n_split.py), falling back to the all-languages file (older patches).
 */
export function fetchJsonLang(url, lang, init) {
	var l = normLang(lang) || 'en';
	var perLang = String(url).replace(/\.json(\?|$)/, '.' + l + '.json$1');
	return fetch(perLang, init).then(function (r) { return r.ok ? r : fetch(url, init); })
		.then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
}
if (typeof window !== 'undefined') window.__huntLangs.fetchJsonLang = fetchJsonLang;
